import { QueryClient, onlineManager } from '@tanstack/react-query';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

onlineManager.setEventListener((setOnline) => {
  const updateOnlineStatus = () => setOnline(navigator.onLine);

  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
  updateOnlineStatus();

  return () => {
    window.removeEventListener('online', updateOnlineStatus);
    window.removeEventListener('offline', updateOnlineStatus);
  };
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 60 * 24,
      retry: (failureCount) => (navigator.onLine ? failureCount < 2 : false),
      networkMode: 'offlineFirst'
    },
    mutations: {
      retry: 2,
      networkMode: 'offlineFirst'
    }
  }
});

export const queryPersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'fuelops-query-cache',
  throttleTime: 1000
});
